import type { CheckpointTask } from "schema/agent";
import { isImageTask, isMusicTask, isVideoTask } from "./validators";

const CREDITS_PER_IMAGE = 15;
const CREDITS_PER_MUSIC = 6;
const CREDITS_PER_VIDEO_SECOND = 10;

export function getCredits(task: CheckpointTask): number {
  if (isImageTask(task)) return CREDITS_PER_IMAGE;
  if (isMusicTask(task)) return CREDITS_PER_MUSIC;
  if (isVideoTask(task)) {
    const duration =
      typeof task.duration === "string" ? parseInt(task.duration, 10) : task.duration;
    return CREDITS_PER_VIDEO_SECOND * duration;
  }
  return 0;
}
